import {AuthGuestActionTypes, AuthGuestCreateAction, AuthState} from "../../types/auth/authGuest";

const initialState: AuthState = {
    authGuestData: null,
    authGuestLoading: false,
    authGuestDataError: null,
};

export const authGuestReducer = (
    state = initialState,
    action: AuthGuestCreateAction,
): AuthState => {
    switch (action.type) {
        case AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA:
            return { ...state, authGuestLoading: true, authGuestDataError: null, authGuestData: null };

        case AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_SUCCESS:
            return { ...state, authGuestLoading: false, authGuestDataError: null, authGuestData: action.payload };
        case AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_ERROR:
            return { ...state, authGuestLoading: false, authGuestDataError: action.payload, authGuestData: null };
        case AuthGuestActionTypes.CLEAR_AUTH_GUEST_DATA:
            return { ...state, authGuestLoading: false, authGuestDataError: null, authGuestData: null };

        default:
            return state;
    }
};